function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(10.272 6.303)"
}, React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(11.297 0.015)"
}, React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M2070.568,1005.474h0a6.8,6.8,0,0,1,1.7-.787c.591-.2,1.264-.462,1.96-.757.507-.227,1.044-.462,1.552-.7a11.1,11.1,0,0,0,3.647-2.384,1.464,1.464,0,0,0,.076-.136l.023-.045h0a1.267,1.267,0,0,1-.083.613,3.436,3.436,0,0,1-.719.946,21.631,21.631,0,0,1-5.3,3.027c-2.46,1.1-3.625,1.809-3.989,2.467A2.626,2.626,0,0,1,2070.568,1005.474Z",
  transform: "translate(-2069.035 -1000.63)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M2067.305,1009.9l.068-.273c.431-1.067,2.7-2.119,6.221-4.23.621-.371,1.15-.719,1.6-1.044h0a.028.028,0,0,1,.015-.008,10.542,10.542,0,0,0,2.195-1.968l.136-.182a2.087,2.087,0,0,0,.257-.454,2.057,2.057,0,0,0,.189-1.09v.008a.508.508,0,0,0-.045-.2c0,2.361-6.395,5.063-8.65,6.16a4.659,4.659,0,0,0-1.65,1.188h0a2.3,2.3,0,0,0-.424,1.892A.485.485,0,0,0,2067.305,1009.9Zm8.657-6.645",
  transform: "translate(-2067.172 -1000.452)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M2067.522,1021.968c-.053-1.582,3.254-3.481,6.145-5.426a16.791,16.791,0,0,0,2.891-2.407,4.4,4.4,0,0,0,1.135-1.922s-.083.129-.386.53a9.418,9.418,0,0,1-1.067,1.022c-.409.341-.787.62-.795.628a49.7,49.7,0,0,1-5.419,3.406,6.4,6.4,0,0,0-2.437,1.968h0a2.375,2.375,0,0,0-.136,1.99A.485.485,0,0,0,2067.522,1021.968Zm9.694-9.118a3.436,3.436,0,0,1-.3.318l.3-.319Z",
  transform: "translate(-2067.275 -1010.154)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M2078.28,1025.878s-.136.8-1.937,2.338c-1.907,1.62-6.584,4.579-6.342,6.894a2,2,0,0,1,.2-2.921,46.324,46.324,0,0,1,4.223-3.171A20.355,20.355,0,0,0,2078.28,1025.878Z",
  transform: "translate(-2069.058 -1021.428)",
  fill: "#fff"
})), React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3"
}, React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M2013.505,1005.474h0a6.8,6.8,0,0,0-1.7-.787c-.59-.2-1.264-.462-1.96-.757-.507-.227-1.044-.462-1.551-.7a11.1,11.1,0,0,1-3.648-2.384,1.492,1.492,0,0,1-.076-.136l-.023-.045h0a1.266,1.266,0,0,0,.083.613,3.435,3.435,0,0,0,.719.946,21.632,21.632,0,0,0,5.3,3.027c2.46,1.1,3.625,1.809,3.988,2.467A2.647,2.647,0,0,0,2013.505,1005.474Z",
  transform: "translate(-2004.209 -1000.615)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M2013.408,1009.607a2.3,2.3,0,0,0-.424-1.892h0a4.66,4.66,0,0,0-1.65-1.188c-2.255-1.1-8.65-3.8-8.65-6.16a.513.513,0,0,0-.045.2v-.008a2.052,2.052,0,0,0,.189,1.09,1.756,1.756,0,0,0,.257.454,1.4,1.4,0,0,0,.136.182,10.54,10.54,0,0,0,2.195,1.968.023.023,0,0,0,.015.007h0c.454.326.984.674,1.6,1.044,3.519,2.112,5.79,3.163,6.221,4.23l.068.272C2013.325,1009.827,2013.385,1009.751,2013.408,1009.607Zm-8.741-6.425h0C2004.675,1003.19,2004.667,1003.19,2004.667,1003.182Z",
  transform: "translate(-2002.628 -1000.367)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M2015.261,1021.755a2.373,2.373,0,0,0-.136-1.99h0a6.552,6.552,0,0,0-2.437-1.968,49.584,49.584,0,0,1-5.419-3.406c-.015-.008-.386-.288-.795-.628a9.4,9.4,0,0,1-1.067-1.022c-.3-.4-.386-.53-.386-.53a4.352,4.352,0,0,0,1.135,1.922,17.146,17.146,0,0,0,2.891,2.406c2.884,1.945,6.2,3.844,6.145,5.427A1,1,0,0,0,2015.261,1021.755Zm-9.475-8.59a3.409,3.409,0,0,1-.3-.318Q2005.616,1012.983,2005.787,1013.165Z",
  transform: "translate(-2004.603 -1010.138)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M2011.81,1025.879s.136.8,1.938,2.338c1.907,1.62,6.584,4.579,6.342,6.894a2,2,0,0,0-.2-2.921,46.318,46.318,0,0,0-4.223-3.171A20.364,20.364,0,0,1,2011.81,1025.879Z",
  transform: "translate(-2010.203 -1021.414)",
  fill: "#fff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14"
}, React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M1985.722,987.468h-2.667V967.91a3.56,3.56,0,0,0-3.556-3.556h-28.447a3.559,3.559,0,0,0-3.556,3.556v19.558h-2.667a.888.888,0,0,0-.889.889v.889a3.559,3.559,0,0,0,3.556,3.556h35.559a3.559,3.559,0,0,0,3.556-3.556v-.889A.888.888,0,0,0,1985.722,987.468Zm-6.223,0h-8.89a.889.889,0,0,0-.4.094l-1.59.8h-6.692l-1.59-.8a.889.889,0,0,0-.4-.094h-8.89V967.91H1979.5v19.558Z",
  transform: "translate(-1943.94 -964.354)",
  fill: "#fff"
})));

var SvgPodWeb = function SvgPodWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_16",
    "data-name": "Group 16",
    width: 42.671,
    height: 28.448,
    viewBox: "0 0 42.671 28.448",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPodWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PodWeb.5c026000.svg";
export { ForwardRef as ReactComponent };